<!--  -->
<template>
  <div class="page">
    <div class="list" v-for="(list, index) in lectureList" :key="index" @click="openPdf(list)">
      <h2>{{ list.name }}</h2>
      <img
        src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/oneToOne/pdf2.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { reqlectureList } from '@/api/index';

export default {
  components: {},
  data() {
    return {
      isApp: this.$root.$data.isApp,
      miniprogram: this.$root.$data.miniprogram,
      lectureList: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    async getLecture(ids) {
      const { data } = await reqlectureList(ids);
      this.lectureList = data || [];
    },
     openPdf(data) {
      const { lectureUrl, name } = data;
      this.$router.push({
        path: '/oneToOnePdfView',
        query: {
          lectureUrl,
          name,
        },
      });
    },
  },
  created() {},
  mounted() {
    document.title = '学习资料';
    this.getLecture(this.$route.query.ids);
  },
};
</script>
<style lang="scss" scoped>
.page {
  padding: 29px 36px;
  background: #F7F8FC;
  .list {
    position: relative;
    width: 678px;
    margin-bottom: 22px;
    padding:43px 29px;
    background: #fff;
    border-radius: 14px;
    h2 {
      padding-right: 36px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
    }
      img {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px;
        height: 34px;
      }
  }
}
</style>
